let configuredModifyBookingEnabled: boolean | undefined = true;

export function setModifyBookingEnabled(enabled: boolean | undefined): void {
    configuredModifyBookingEnabled = enabled;
}

/** When chain-info omits the field, ETA save stays enabled (legacy default). */
export function isModifyBookingEnabled(): boolean {
    return configuredModifyBookingEnabled !== false;
}
